export function setKeyValue(key, value) {
  let current = getHistory()
  if (!current) current = {}
  current[key] = value
  localStorage.setItem('history', JSON.stringify(current))
}

export function clearHistory () {
  localStorage.setItem('history', JSON.stringify({}))
}

export function getKeyValue(key) {
  const history = getHistory()
  return history && typeof history[key] !== 'undefined' ? history[key] : undefined
}

export function getHistory() {
  return JSON.parse(localStorage.getItem('history'))
}
